import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {useIntegrityProfGral} from '../hooks';

const IntegrityProfGral = (props: any) => {
  const loadProfSpac = useIntegrityProfGral(props.data.key);

  return (
    <IntegrityRoleGrid
      dataSource={loadProfSpac}
      disabledExport={true}
      autoWidth={false}
      id={['revision']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
    >
      <Column
        caption={`#${i18n2._('Profile-General')}`}
        defaultSortOrder={'asc'}
        dataField="iD_ProfGral"
      />
      <Column
        caption={`${i18n2._('Profile-General')} ${i18n2._('Descripcion')}`}
        dataField="Description"
        width={200}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default IntegrityProfGral;
